import { parse } from 'querystring';
import { Config } from '@catalogo/core-configuration';
import { PageLoadEvent } from '../../../types/events';
import { PageViewDefaultEvent } from '../../../types/datalayer/pageview';
import { PAGETYPES } from '../../../types/datalayer/datalayer';
import { getEventName } from './helpers';
import getDefaultEventPayload from '../default-event';

export default (pageload: PageLoadEvent, config: Config): PageViewDefaultEvent => {
  const parsedQs = parse(window.location.search.replace('?', ''));
  const { type } = pageload.detail?.page;
  const pagetype = PAGETYPES[type] || 'outros';

  const defaultEventPayload = getDefaultEventPayload(pageload, config);

  return {
    ...defaultEventPayload,
    event: getEventName(pagetype.toLowerCase()),
    afpid: parsedQs?.afpid,
  } as PageViewDefaultEvent;
};
